import React, { useEffect, useState } from 'react';
import { ReactComponent as Pencil } from 'assets/icons/pencil.svg';
import { Modal } from 'components';
import { Input } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { validateOtp, getOtp } from 'store/forms/actions';
import { isNil } from 'lodash';

const OtpModal = ({ isVisible, setVisible, otpValidateParams, cancelOtp, setCancelOtp }) => {
    const dispatch = useDispatch();
    const [otp, setOtp] = useState('');
    const [otpError, setOtpError] = useState('');
    const task = useSelector(state => state.forms.task);
    const carrier = useSelector(state => state.forms.carrier);
    const getOtpError = useSelector(state => state.forms.carrier.getOtpError);

    const handleOk = () => {
       const params = {
        ...otpValidateParams,
        otp,
       }
       
       dispatch(validateOtp(params))
    }

    const handleCancel = () => {
        setVisible(false); 
        setOtp(''); 
        setOtpError('');
        setCancelOtp(otpValidateParams.field)
    }

    useEffect(()=>{
        if(carrier?.otpError){ 
            setOtpError('Δεν είναι σωστός ο κωδικός OTP. Προσπαθήστε ξανά.')
        }else {
            setVisible(false);
            setOtp('');
            setOtpError('');
        }
    },[carrier])

    const verifyOtp = () => {
        const params = {
          processInstanceId: task.processInstanceId,
          fieldName: otpValidateParams.fieldName,
          fieldValue : carrier?.[otpValidateParams?.field],
          field: otpValidateParams.field,
        }
        if(otpValidateParams.field){
          dispatch(getOtp(params));
        }
      }

    return (
      <Modal
        isVisible={isVisible}
        Icon={Pencil}
        onCancel={() => handleCancel()}
        onOk={()=> handleOk()}
        title={<h1 style={{color:"#2d97e9", marginTop:"0.563rem", marginLeft:"1.875rem"}}>
            {otpValidateParams.fieldName === 'mobile' ? 'Επαλήθευση Αρ.Τηλεφώνου': ' Επαλήθευση Email'}  </h1>}
        width={817}
        okText="Επιβεβαίωση"
        cancelText="Ακύρωση"
      >
        <>
        <div className='otp-modal-description'>
            {otpValidateParams.fieldName === 'mobile' ?(
            <>
              <div>
                Σας έχει αποσταλεί κωδικός επαλήθευσης (OTP) στον αριθμό
                τηλεφώνου που καταχωρήσατε.
              </div>
              <div>
                Παρακαλούμε εισαγάγετε τον κωδικό στο αντίστοιχο πεδίο για να
                ολοκληρώσετε την επαλήθευση.
              </div>
              <div>Αν δεν λάβατε τον κωδικό, παρακαλούμε προσπαθήστε ξανά.</div>
            </>
          ) : (
            <>
              <div>
                Σας έχει αποσταλεί κωδικός επαλήθευσης (OTP) στο email που
                καταχωρήσατε.
              </div>
              <div>
                Παρακαλούμε εισαγάγετε τον κωδικό στο αντίστοιχο πεδίο για να
                ολοκληρώσετε την επαλήθευση.
              </div>
              <div>
                Αν δεν λάβατε τον κωδικό, ελέγξτε τα ανεπιθύμητα μηνύματα ή
                ζητήστε νέο κωδικό.
              </div>
            </>
          )}
        </div>
        <div style={{marginTop:"20px"}}>
            <span className='input-titles'>Κωδικός OTP</span>
            <Input 
                style={{height:"40px"}} 
                value={otp} 
                onChange={event=>{setOtp(event.target.value)}}>
            </Input>
            <div>
            <a onClick={(e) => {
                              e.preventDefault();
                              verifyOtp();
                           }}
                            rel="noopener noreferrer">
                              Επαναποστολή Κωδικού
                          </a>
            </div>
            {otpError && <span style={{color: '#ff4d4f'}}>{otpError}</span>}
            {getOtpError && <span style={{color: '#ff4d4f'}}>{'Παρακαλούμε δοκιμάστε ξανά.'}</span>}
        </div>
        </>
      </Modal>
    );
  };
  
  export default OtpModal;